<template>
  <div>
    <Header v-if="showHref"></Header>
    <div class="info">
      <div class="out">
        <div class="content">
          <h1>法律声明</h1>

          <h3>1.服务条款协议</h3>
          <p>
            华为技术有限公司欢迎您参加华为伙伴暨开发者大会2022。本服务协议条款和条件（“本协议”），是您与华为技术有限公司和/或其关联公司就华为伙伴暨开发者大会2022等相关事宜订立的契约，就您在本协议中的权利、义务等重要信息作出了约定，具有法律约束力。
          </p>
          <p>
            本协议适用于网址为<a
              :href="
                showHref
                  ? 'https://e-campaign.huawei.com/campaign/partner-developer2022'
                  : '#'
              "
              >https://e-campaign.huawei.com/campaign/partner-developer2022</a
            >的网站，以及华为技术有限公司和/或其关联公司就华为伙伴暨开发者大会2022链接到<a
              :href="
                showHref
                  ? 'https://e-campaign.huawei.com/campaign/partner-developer2022'
                  : '#'
              "
              >https://e-campaign.huawei.com/campaign/partner-developer2022</a
            >的所有相关网站、APP等应用软件（合称为“本网站”）。本网站是华为技术有限公司的财产。请您认真阅读并充分理解本协议，<span
              style="font-weight: bold"
              >凡以任何行为实际使用本网站（包括但不限于注册、第三方代注册、登录、使用、浏览等），从本网站购买产品或享用服务，接受华为伙伴暨开发者大会2022邀请函或参与华为伙伴暨开发者大会2022，即表示您已仔细阅读并接受了本协议，同意本协议项下包括但不限于隐私保护和责任限制、免除等条款在内的所有内容及其法律约束力。如您不同意，请勿使用本网站、在本网站上购买产品或享用服务及参与华为伙伴暨开发者大会2022，也勿点击下方的“我同意”</span
            >。
          </p>
          <p>
            本协议中的“华为”是指华为技术有限公司和/或其关联公司。本协议中的“您”，包括但不限于您、您的雇主、代理人、及代表您同意和接受本协议的任何主体或个人。当您使用本网站，您应当年满18周岁，并具备完全民事权利能力和完全民事行为能力，能够独立承担法律责任，否则华为保留自行决定在任何时候拒绝向您提供服务的权利。对由此给华为或第三方造成的损失，您须承担全部赔偿责任。如您为无民事行为能力人或为限制民事行为能力人，则只能在父母或监护人的监护参与下才能使用本网站，否则华为有权在法律允许范围内冻结、关闭或删除您的账户。
          </p>
          <p>
            华为保留自行决定在任何时候变更、修改、增加或删除本协议、本网站部分内容的权利，不再另行通知。所有变更、修改、增加或删除的本协议或本网站的内容，自在本网站上更新时生效，并适用于以任何方式参与华为伙伴暨开发者大会2022、使用任何与华为伙伴暨开发者大会2022相关的应用程序和服务。鉴于受到互联网技术发展水平等因素的限制，本网站不排除部分信息会存在滞后或差错的可能性。您确认知悉和理解此情形，并同意不追究华为的相关责任。您有责任定期查看本协议的变更。您在变更信息发布之后继续使用本网站、参与华为伙伴暨开发者大会2022或使用任何与华为伙伴暨开发者大会2022相关的应用程序和服务，即表示您同意且接受该等变更。
          </p>
          <h3>2.提供的产品或服务内容</h3>
          <p>
            华为伙伴暨开发者大会2022 自2022 年6 月15 日至2022 年6 月16
            日举行。本网站负责提供与华为伙伴暨开发者大会2022相关的账户注册信息、咨询、议程、信息推荐。您不可为任何非法或本协议禁止之目的使用本网站或华为伙伴暨开发者大会2022相关的任何内容，或者为教唆实施任何非法行为或侵犯华为或他人权利的其他行为使用本网站或华为伙伴暨开发者大会2022相关的任何内容。
          </p>
          <h3>3.第三方链接</h3>
          <p>
            本网站可能保留有与第三方网站或网址的链接，访问这些链接将由用户自己作出决定，华为并不保证这些链接上所提供的任何信息、数据、观点、图片、陈述或建议的准确性、完整性、充分性和可靠性。华为提供这些链接仅仅在于提供方便，并不表示华为对这些信息的认可和推荐，也不是用于宣传或广告目的。
          </p>
          <h3>4.所有权及知识产权</h3>
          <p>
            本网站及华为伙伴暨开发者大会2022所载的所有文字、图表、用户界面、可视界面、图片、商标、标识、声音、音乐、美术作品及计算机编码（合称为“内容”），为华为所有、受华为控制或许可给华为使用，且受商业外观法、著作权法、专利法、商标法以及各类其他知识产权法和反不正当竞争法的保护。除本协议明确规定外，未经华为事先书面同意，您不得将本网站及华为伙伴暨开发者大会2022的任何内容及与其有关的派生产品，以任何方式进行复制、经销、翻印、播放、以超级链路连接或传送、存储于信息检索系统或者其他任何商业目的的使用。
          </p>
          <p>
            您可以使用华为专为从本网站下载所提供的有关本网站和华为伙伴暨开发者大会2022的信息，但仅限于出于个人而非商业信息目的使用该等信息，且不得在任何网络计算机上复制或发布该等信息，或在任何媒介上散布该等信息；不得从该等文件的所有复本中移除任何所有权通知的文句；不得对该等信息作任何修改；不得对该等文件做出进一步陈述或保证。
          </p>
          <h3>5.图像使用</h3>
          <p>
            您确认并同意，华为及其代理商可能会在华为伙伴暨开发者大会2022上对您采访、拍摄照片及/或录制视频。因此，您同意，在此授权华为及其代理商在全球范围内，以任何方式或媒体，包括但不限于印刷、互联网或其他电子形式，使用、复制、传输、广播、公开发行及展示您的图像/照片、视频、声音、采访内容等（可同时附加/不附加您的姓名），用于华为伙伴暨开发者大会2022的推广、营销与宣传。华为是上述作品的唯一、排他的知识产权所有者，且您无权要求审核上述作品或提出赔偿请求及其他因此使用而引起的任何法律主张，并同意华为及其代理商无需对此承担任何责任。
          </p>
          <p>
            除非是出于合法的新闻报道和媒体传播等合理正当目的，否则，未经华为事前书面同意，您不得出于商业目的从事以下行为：在华为伙伴暨开发者大会2022上使用任何设备拍照、录音、直播、复制华为伙伴暨开发者大会2022上的讲演、展示和相关材料等，也不得通过任何途径传播上述信息和材料。任何情况下，直播需获得华为事前同意。如您违反上述规定，华为有权请您退出华为伙伴暨开发者大会2022，且无需承担任何赔偿责任。
          </p>
          <h3>6. 华为伙伴暨开发者大会2022行为守则</h3>
          <p>
            您同意，您不得以参与华为伙伴暨开发者大会2022的名义，向其他参会者或展览者寻求与华为伙伴暨开发者大会2022无关的合作机会。在华为伙伴暨开发者大会2022举办期间及前后三天内，您不得在华为伙伴暨开发者大会2022上邀请或鼓动其他参会者参加附近的其他会展或离开华为伙伴暨开发者大会2022。如您违反上述约定，华为有权请您退出华为伙伴暨开发者大会2022，且无需承担任何赔偿责任。
          </p>
          <p>
            您可以自愿参加华为伙伴暨开发者大会2022上的一些活动或展示，并自行承担责任和风险。华为不会强制要求您参加任何活动或展示。除因华为的重大过失或故意导致的损害外，华为不承担任何因您自愿参加活动或展示所导致的人身、财产的损害赔偿责任。
          </p>
          <h3>7.不可抗力</h3>
          <p>
            “不可抗力”是指华为不能预见、不能避免且不能克服的客观状况，包括但不限于疫情、地震、台风、洪水、火灾、疫病、战争、恐怖主义行为、政府行为、罢工、法律规定、航班取消、第三方未能提供产品或服务等。不可抗力事件发生后，华为无须为此承担任何责任，但将尽最大努力履行其义务并减少由于不可抗力事件给您造成的损失。
          </p>
          <h3>8.责任限制及赔偿条款</h3>
          <p>
            您同意，就华为发生的或遭受的、由于您使用本网站、参加华为伙伴暨开发者大会2022或相关活动所引发或以任何形式与之相关的任何一切人身或财产相关的主张、责任、损失、损害以及政府费用或罚款、处罚、支出、法律费用、专业人员费用和其他任何性质的费用（合称“索赔”）（包括但不限于因您的雇员、代理人、承包商以及参加人员的重大过失或故意不当行为导致的索赔），您始终就该等索赔向华为承担责任、进行赔偿、为其抗辩并使其免受损害。
          </p>
          <p>
            如您违反本协议项下条款或未能遵从华为提出的合理要求，华为有权请您退出华为伙伴暨开发者大会2022，且无需承担任何赔偿责任。
          </p>
          <p>
            华为及其代理商不能控制为华为伙伴暨开发者大会2022提供住宿及其他服务的独立供应商的行为。因此，华为不对任何由上述供应商的作为/不作为引起的或超出华为及其代理商控制范围内的责任、损失、损害及诉讼等承担赔偿责任。
          </p>
          <p>
            除法律禁止外，在任何情形下，华为对任何间接、派生、附带或惩罚性损害，包括但不限于利益损失，不向您承担责任，即便华为已被告知发生该等损害的可能。
          </p>
          <h3>9.协议的终止</h3>
          <p>
            本协议自您点击“我同意”时起生效并具备法律效力，各方全部义务履行完毕之日或本协议解除之日为到期日。本协议终止或到期后，依约定或条款性质应该继续生效、对双方继续具有约束力的条款除外，包括但不限于所有权及知识产权、图像使用、责任免除、限制及赔偿条款等。<span
              style="font-weight: bold"
              >华为保留在任何时候单方面解除本协议或拒绝您参加华为伙伴暨开发者大会2022的权利，在通知到达您的注册邮箱后立即生效</span
            >。
          </p>
          <h3>10.免责声明</h3>
          <p style="font-weight: bold">
            您明确同意本网站及/或华为伙伴暨开发者大会2022提供的产品或服务的使用由您个人自行承担风险。除法律另有规定外，华为不对本网站及/或华为伙伴暨开发者大会2022的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明、承诺或担保。华为不保证服务一定能满足您的要求，也不保证服务不会受中断，对服务的及时性、安全性、出错都不作任何承诺和保证。
          </p>
          <h3>11.协议的完整性</h3>
          <p>
            本协议及产品和服务订单的相关通知构成您与华为就本协议约定的本网站及/或本协议所提及的华为伙伴暨开发者大会2022事项达成的完整协议，并取代双方之前与本网站及/或本协议所提及的华为伙伴暨开发者大会2022事项有关的一切口头和书面的、明示和默示的洽谈、谈判、通知、备忘录、文件、协议、合同和通讯。
          </p>
          <h3>12.适用法律及争议解决</h3>
          <p>
            您同意，本协议的签订地约定为深圳市龙岗区。华为伙伴暨开发者大会2022及/或本协议的订立、执行、解释及争议的解决均应适用在中华人民共和国大陆地区的有效法律。如本协议部分条款与适用法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。如双方就华为伙伴暨开发者大会2022及/或本协议的内容或其执行发生任何争议，双方应尽力友好协商解决，协商不成时，任何一方应且只能向本协议签订地有管辖权人民法院以诉讼的方式解决。
          </p>
          <h3>13.其他</h3>
          <p>
            华为不对其不可预见或超出其控制范围的损失承担责任。可预见的损失，是指您与华为在订立本协议时，已明确约定的华为因违反本协议而造成的明显的损失与责任。
          </p>
          <p>
            您同意，根据华为伙伴暨开发者大会2022的管理要求和安全规定，在华为伙伴暨开发者大会2022上的一部分活动、展示、研讨及分展会（合称“分会”），仅对某些参会者开放。未经华为明确的书面授权或邀请，华为有权拒绝您进入和/或请您退出上述分会。
          </p>
          <p>
            除明确约定外，华为迟延行使或未行使本协议项下某条或若干条条款中的权利，迟延要求或未要求您履行您在本协议中的义务，均不应被理解为华为放弃上述权利。且您无权对本协议中的任何条款、条件或部分作出变更。
          </p>
          <p style="font-weight: bold">
            您同意并认可，您已年满18周岁，并具备完全民事权利能力和完全民事行为能力，能够独立承担法律责任，且已仔细阅读本协议上述全部条款。通过点击“我已阅读并同意华为公司法律声明”，您即承认您已阅读并同意本协议项下包括但不限于隐私保护和责任限制、免除等条款在内的所有内容及其法律约束力。如您不同意，请勿使用本网站、在本网站上购买产品或享用服务及参与华为伙伴暨开发者大会2022，也勿点击下方的“我已阅读并同意华为公司法律声明”。
          </p>
        </div>
      </div>
    </div>
    <foot v-if="showHref"></foot>
  </div>
</template>

<script>
import Header from "../../components/Header";
import Foot from "../../components/Foot";
export default {
  name: "legal",
  data() {
    return {
      pageHeight: "",
      height: document.documentElement.clientHeight,
      width: document.documentElement.clientWidth,
      showHref: true,
    };
  },
  components: {
    Header,
    Foot,
  },
  mounted() {
    if (!this.$route.query.type) {
      console.log("正常进入");
    } else {
      if (this.$route.query.type == "mini") {
        this.showHref = false;
        console.log("小程序进入");
      }
    }
  },
};
</script>
<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.info {
  position: relative;
  width: 100%;
  // height: 100vh;
  overflow: hidden;
  // background: url('../assets/newImages/common/common-bg.png')no-repeat center center/cover;
  background: white;
  font-family:  Microsoft YaHei-Light;
  font-weight: 400;
  .out {
    margin: 135px 300px;
    .content {
      a {
        color: blue;
      }
      ul {
        padding-left: 20px;
      }
      li {
        font-size: 20Px;
        list-style: disc;
        color: #666;
        margin-bottom: 20px;
        line-height: 39px;
        text-align: left;
      }
      h1 {
        text-align: center;
        font-size: 38Px;
        color: #000;
        line-height: 30px;
        padding: 20px 0 30px;
      }
      h2 {
        font-size: 32Px;
        line-height: 30px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
      }
      h3 {
        font-size: 26Px;
        line-height: 30px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
      }
      h4 {
        font-size: 22Px;
        line-height: 30px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
      }
      p {
        font-size: 16Px;
        color: #666;
        margin-bottom: 20px;
        line-height: 39px;
        text-align: left;
        // text-indent: 40px;
      }
      .eight {
        font-weight: bold;
      }
      a {
        font-size: 16Px;
        color: #666;
        line-height: 39px;
        text-align: left;
        text-decoration: underline;
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .info {
    width: 100%;
    min-height: 100vh;
    padding: 10vw 0 13.3vw;
    // background: url('../assets/newImages/common/navWap/page-bg.png')no-repeat center center/cover;
    background: white;
    font-family:  Microsoft YaHei-Light;
    font-weight: 400;
    .out {
      width: 100%;
      margin: 0;
      padding-right: 0;
      // border-top: 1px solid #DDDDDD;
      .content {
        width: auto;
        padding: 0 5.33vw;
        background: none;
        ul {
          padding-left: 20px;
        }
        li {
          list-style-type: disc;
          font-size: 20Px;
          color: #666;
          margin-bottom: 20px;
          line-height: 1.5;
          text-align: left;
        }
        h1 {
          text-align: center;
          color: #000;
          font-size: 30Px;
          line-height: 60Px;
          padding: 20px 0 0;
          margin-bottom: 30px;
        }
        h2 {
          font-size: 28Px;
          line-height: 30px;
          font-weight: bold;
          color: #333;
          margin-bottom: 30px;
        }
        h3 {
          font-size: 26Px;
          line-height: 40Px;
          font-weight: bold;
          color: #333;
          margin-bottom: 30px;
        }
        h4 {
          font-size: 22Px;
          line-height: 30px;
          font-weight: bold;
          color: #333;
          margin-bottom: 30px;
        }
        p {
          font-size: 12.8Px;
          color: #666;
          margin-bottom: 30px;
          line-height: 25Px;
          text-align: left;
          padding: 0 20px;
          // text-indent: 40px;
        }
      }
    }
  }
}
</style>
